module.exports = __webpack_public_path__ + "static/media/vctr-small-down-arrow.6b855fda.svg";